var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 16,
    fill: "#EFF0FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 19L23.8845 16.7689C23.5634 16.1268 23.4029 15.8057 23.1634 15.5712C22.9516 15.3637 22.6963 15.206 22.4161 15.1093C22.0992 15 21.7402 15 21.0223 15H17.2C16.0799 15 15.5198 15 15.092 15.218C14.7157 15.4097 14.4097 15.7157 14.218 16.092C14 16.5198 14 17.0799 14 18.2V19M14 19H29.2C30.8802 19 31.7202 19 32.362 19.327C32.9265 19.6146 33.3854 20.0735 33.673 20.638C34 21.2798 34 22.1198 34 23.8V28.2C34 29.8802 34 30.7202 33.673 31.362C33.3854 31.9265 32.9265 32.3854 32.362 32.673C31.7202 33 30.8802 33 29.2 33H18.8C17.1198 33 16.2798 33 15.638 32.673C15.0735 32.3854 14.6146 31.9265 14.327 31.362C14 30.7202 14 29.8802 14 28.2V19Z",
    stroke: "#6366F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.2aa4d681a9c381793b806031c88fa805.svg";
export { ForwardRef as ReactComponent };